import React from 'react'
import { Container, Row } from 'react-bootstrap'
import useFetchData from '../../hooks/use-fetch-service';

//import { ScrollerWrapper } from './ScrollerIcon.style';
import './style.css';
import TabView from '../tabview/TabView';

function ScrollerIcon() {
    const { data } = useFetchData();

    const chunk1 = data.slice(2, 3);
    const chunk2 = data.slice(3, 4);
    const chunk3 = data.slice(4, 5);
    const chunk4 = data.slice(5, 6);
    const chunk5 = data.slice(1, 2);

    const text1 = <img src={`${chunk4.map(item => item.id == 148 ? item._embedded['wp:featuredmedia']['0'].source_url : null ) }`} />;
    
    let title1 = <h4>{`${chunk4.map(item => item.id == 148 ? item.title.rendered : null ) }`}</h4>;
  
    const content = <div>{`${chunk4.map(item => item.id == 148 ? item.content.rendered : null)}`}</div>;

    const images = <img src={`${chunk4.map(item => item.id == 148 ? item.acf.post_images : null )}`} />

    const text2 = <img src={`${chunk3.map(item => item.id == 156 ? item._embedded['wp:featuredmedia']['0'].source_url : null ) }`} />;

    const title2 = <h4>{`${chunk3.map(item => item.id == 156 ? item.title.rendered : null ) }`}</h4>;

    const content2 = <div>{`${chunk3.map(item => item.id === 156 ? item.content.rendered : null)}`}</div>;

    const image2 = <img src={`${chunk3.map(item => item.id == 156 ? item.acf.post_images : null )}`} />

    const text3 = <img src={`${chunk2.map(item => item.id == 159 ? item._embedded['wp:featuredmedia']['0'].source_url : null ) }`} />;

    const title3 = <h4>{`${chunk2.map(item => item.id == 159 ? item.title.rendered : null ) }`}</h4>;

    const content3 = <div>{`${chunk2.map(item => item.id === 159 ? item.content.rendered : null)}`}</div>;

    const image3 = <img src={`${chunk2.map(item => item.id == 159 ? item.acf.post_images : null )}`} />

    const text4 = <img src={`${chunk1.map(item => item.id == 163 ? item._embedded['wp:featuredmedia']['0'].source_url : null ) }`} />;

    const title4 = <h4>{`${chunk1.map(item => item.id == 163 ? item.title.rendered : null ) }`}</h4>;

    const content4 = <div>{`${chunk1.map(item => item.id === 163 ? item.content.rendered : null)}`}</div>;

    const image4 = <img src={`${chunk1.map(item => item.id == 163 ? item.acf.post_images : null )}`} />

    const text5 = <img src={`${chunk5.map(item => item.id == 169 ? item._embedded['wp:featuredmedia']['0'].source_url : null ) }`} />;

    const title5 = <h4>{`${chunk5.map(item => item.id == 169 ? item.title.rendered : null ) }`}</h4>;

    const content5 = <div>{`${chunk5.map(item => item.id === 169 ? item.content.rendered : null)}`}</div>;

    const image5 = <img src={`${chunk5.map(item => item.id == 169 ? item.acf.post_images : null )}`} />

    

  console.log(data);
return (
  
    <div className='scroller-icons'> 
      <Container>
          <Row>
              <TabView 
              tabs={[ 
                { name: text1, title: title1, content: content, image: images },
                { name: text2, title: title2, content: content2, image: image2 },
                { name: text3, title: title3, content: content3, image: image3 },
                { name: text4, title: title4, content: content4, image: image4},
                { name: text5, title: title5, content: content5, image: image5},
              ]}
              />
          </Row>
      </Container>
    </div>
  )
}

export default ScrollerIcon